module.exports = __webpack_public_path__ + "img/zoombies_nft_icon.1c1e81f4.webp";